var React = require('react');

function Fi (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"256","cy":"256","r":"256","fill":"#eee","key":0}),React.createElement("path",{"fill":"#0052b4","d":"M509.8 222.6H200.3V6.1a254.3 254.3 0 0 0-66.7 25v191.5H2.2a258.2 258.2 0 0 0 0 66.8h131.4v191.5a254.3 254.3 0 0 0 66.7 25V289.4h309.5a258.6 258.6 0 0 0 0-66.8z","key":1})]);
}

Fi.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Fi;

Fi.default = Fi;
